import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import { TextField } from '@mui/material';
import Input from '@mui/material/Input';
import { Button } from '@material-ui/core';
const ariaLabel = { 'aria-label': 'description' };

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Nama',
  },
  {
    id: 'phoneNumber',
    numeric: true,
    disablePadding: false,
    label: 'Nomor Telepon',
  },
  {
    id: 'email',
    numeric: true,
    disablePadding: false,
    label: 'Email',
  },
  {
    id: 'desc',
    numeric: true,
    disablePadding: false,
    label: 'Keterangan',
  }
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, handleNewRow } = props;

  return (
    <TableHead>
      <TableRow
        sx={{
        borderBottom: "1px solid black",
        "& th": {
        color: "rgba(96, 96, 96)"
        }
      }}
      >
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.label}
          </TableCell>
        ))}
          <TableCell
            align="center"
          >
      <Button
        type="submit"
        className="font-size-12 btn-black text-transform-unset"
        style={{ height:'25px', width:'125px'}}
        onClick={handleNewRow}
      >
        + Tambah Baris
      </Button>
          </TableCell>

      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  handleNewRow: PropTypes.func.isRequired
};

// const EnhancedTableToolbar = (props) => {
//   const { numSelected } = props;

//   return (
//     <Toolbar
//       sx={{
//         pl: { sm: 2 },
//         pr: { xs: 1, sm: 1 },
//         ...(numSelected > 0 && {
//           bgcolor: (theme) =>
//             alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
//         }),
//       }}
//     >
//       {
//         numSelected > 0 && (
//           <Typography
//             sx={{ flex: '1 1 100%' }}
//             color="inherit"
//             variant="subtitle1"
//             component="div"
//           >
//             {numSelected} selected
//           </Typography>
//         )

//       }

//       {numSelected > 0 && (
//         <Tooltip title="Delete">
//           <IconButton>
//             <DeleteIcon />
//           </IconButton>
//         </Tooltip>
//       )}
//     </Toolbar>
//   );
// };

export default function UploadContactRow({ contactArray }) {
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState([])
  const [newRow, setNewRow] = useState({
    name: '',
    number: '',
    email: '',
    desc: ''
  })

  useEffect(() => {  
    contactArray(rows)
  }, [rows])

  const handleChangeInputTable = (e) => {
    let { name, value } = e.target
    setNewRow({ ...newRow, [name]: value })
  }

  const handleNewRow = () => {
    const rows_temp = [...rows, newRow]
    setRows(JSON.parse(JSON.stringify(rows_temp)))
    const cleanupInput = {
      name: '',
      number: '',
      email: '',
      desc: ''
    }    
    setNewRow(JSON.parse(JSON.stringify(cleanupInput)))
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer
          component={Paper}
          sx={{
            border: "1px solid black",
            padding: 1,
            backgroundColor: "#ebebeb"
          }}
        >
          <Table
            style={{ marginBottom:'100px', width: "auto", tableLayout: "auto" }}
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none"
              }
            }}

            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={rows.length}
              handleNewRow={handleNewRow}
            />
            <TableBody>
              {
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        <Input className="font-size-12" value={row.name}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{width: '100px', paddingLeft:'20px'}}>
                        <Input className="font-size-12" value={row.number}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{width: '200px', paddingLeft:'20px'}}>
                        <Input className="font-size-12" value={row.email}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{paddingLeft:'20px'}}>
                        <Input className="font-size-12" value={row.desc}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{paddingLeft:'20px'}}>
                        <DeleteIcon />
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
                    <TableRow
                      role="checkbox"
                    >
                      <TableCell padding="checkbox">
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        <Input className="font-size-12" onChange={handleChangeInputTable} name='name' value={newRow.name}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{paddingLeft:'20px'}}>
                        <Input className="font-size-12" onChange={handleChangeInputTable} name='number' value={newRow.number}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{paddingLeft:'20px'}}>
                        <Input className="font-size-12" onChange={handleChangeInputTable} name='email' value={newRow.email}/>
                      </TableCell>
                      <TableCell align="center" padding="none" style={{paddingLeft:'20px'}}>
                        <Input className="font-size-12" onChange={handleChangeInputTable} name='desc' value={newRow.desc}/>
                      </TableCell>
                    </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
}